import React from "react";
import { FormattedMessage } from "react-intl";
import {
  FormLabelRenderer,
  type FormLabelType,
} from "src/shared/forms/formrenderers/FormLabelRenderer";

export interface IPleaseSelectProps {
  children?: FormLabelType;
}

export const PleaseSelect = ({
  children = <FormattedMessage id="form.select" />,
}: IPleaseSelectProps) => {
  return (
    <FormLabelRenderer label={children}>
      {(message) => <option value="">{message}</option>}
    </FormLabelRenderer>
  );
};

/**
 * @deprecated
 */
export default PleaseSelect;
